import firebase from "firebase";
import isValidCnpj from "@brazilian-utils/is-valid-cnpj";
import formatCnpj from "@brazilian-utils/format-cnpj";

var config = {
  apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
  authDomain: "tourbrazil-41fbe.firebaseapp.com",
  databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
  projectId: "tourbrazil-41fbe",
  storageBucket: "tourbrazil-41fbe.appspot.com",
  messagingSenderId: "927605208400"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const Nome = e => {
  return dispatch => {
    return dispatch({ type: "NOME", payload: e });
  };
};

export const Email = e => {
  return dispatch => {
    return dispatch({ type: "EMAIL", payload: e });
  };
};

export const Senha = e => {
  return dispatch => {
    return dispatch({ type: "SENHA", payload: e });
  };
};

export const Logo = e => {
  return dispatch => {
    dispatch({
      type: "CADASTRO_STATE",
      payload: "Aguarde, Enviando Imagem..."
    });
    var file = e.target.files[0];

    // Referenciar o Storage
    var storageRef = firebase.storage().ref("empImages/" + file.name);

    // Enviar o arquivo
    var task = storageRef
      .put(file)
      .then(snapshot => {
        return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
      })

      .then(downloadURL => {
        console.log(
          `Successfully uploaded file and got download link - ${downloadURL}`
        );
        dispatch({ type: "CADASTRO_STATE", payload: "" });
        return dispatch({ type: "LOGO", payload: downloadURL });
      })

      .catch(error => {
        // Use to signal error if something goes wrong.
        console.log(`Failed to upload file and get link - ${error}`);
      });
  };
};

export const Categoria = e => {
  return dispatch => {
    return dispatch({ type: "CAT", payload: e });
  };
};

export const Rua = e => {
  return dispatch => {
    return dispatch({ type: "RUA", payload: e });
  };
};

export const Cidade = e => {
  return dispatch => {
    return dispatch({ type: "CIDADE", payload: e });
  };
};

export const RuaAuto = e => {
  return dispatch => {
    return dispatch({ type: "RUA", payload: e });
  };
};

export const CidadeAuto = e => {
  return dispatch => {
    return dispatch({ type: "CIDADE", payload: e });
  };
};

export const Cep = e => {
  return dispatch => {
    return dispatch({ type: "CEP", payload: e });
  };
};

export const Cnpj = e => {
  return dispatch => {
    isValidCnpj(e) === false
      ? dispatch({ type: "CNPJ_VALIDATE", payload: "Digite um CNPJ Válido!" })
      : dispatch({ type: "CNPJ_VALIDATE", payload: "CNPJ Válido!" });
    dispatch({ type: "CNPJ", payload: formatCnpj(e) });
  };
};

export const Fone = e => {
  return dispatch => {
    return dispatch({ type: "FONE", payload: e });
  };
};

export const Face = e => {
  return dispatch => {
    return dispatch({ type: "FACE", payload: e });
  };
};

export const Site = e => {
  return dispatch => {
    return dispatch({ type: "SITE", payload: e });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/cadastroInputs.js